<mat-card fxFlex="100%" class="user-card-content" >
<mat-card-content fxLayout="row" fxLayoutAlign="space-between center">

  <!-- LEFT SECTION -->
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="25%">
    <div class="avatar">
      {{ userData.userDetails?.nameIcon | uppercase }}
    </div>

    <div class="username">
      {{ userData.userDetails?.usernameDec }}
    </div>
  </div>

  <!-- EMAIL -->
  <div class="info-block"
       fxLayout="column"
       fxLayoutAlign="start start"
       fxFlex="20%">
    <div class="label">Email</div>
    <div class="value">
      {{ userData.userDetails?.emailDec }}
    </div>
  </div>

  <!-- JOIN DATE -->
  <div class="info-block"
       fxLayout="column"
       fxLayoutAlign="start start"
       fxFlex="20%">
    <div class="label">Join Date</div>
    <div class="value">
      {{ userData.userDetails?.dateOfJoining | date:'MMM d, yyyy h:mm a' }}
    </div>
  </div>

  <!-- LAST ACTIVE -->
  <div class="info-block"
       fxLayout="column"
       fxLayoutAlign="start start"
       fxFlex="20%">
    <div class="label">Last Active Date</div>
    <div class="value">
      {{ userData.userDetails?.active | date:'MMM d, yyyy h:mm a' }}
    </div>
  </div>

  <!-- ROLE -->
  <div class="info-block"
       fxLayout="column"
       fxLayoutAlign="start start"
       fxFlex="15%">
    <div class="label">Role</div>
    <span
      class="role-pill"
      [ngClass]="(userData.userDetails?.userRole === 'Member' || userData.userDetails?.userRole === 'Guest')
        ? 'member-pill'
        : 'organizer-pill'">
      {{ userData.userDetails?.userRole | titlecase }}
    </span>
  </div>

</mat-card-content>
 </mat-card>